export default __webpack_public_path__ + "static/media/Background_00062.eed9afea.png";